import Api from './rest/CrmFunnelMemberApi';

export default new Api();
